import { Injectable } from '@angular/core';
import { combineLatest, map, shareReplay, tap } from 'rxjs';

// --- Services ---
import { MenuLayoutService } from '@services/menu-layout.service';

// --- Stores ---
import { MenuLayoutStore } from '@stores/menu-layout.store';

// --- Interfaces ---
import type { ICategoryMenu } from '@interfaces/category';
import type { IMenuLayout } from '@interfaces/menuLayout';

@Injectable({
	providedIn: 'root',
})
export class MenuLayoutFacade {
	menuLayout!: IMenuLayout;

	readonly menuLayoutState$ = combineLatest([
		this.menuLayoutStore.menuLayoutState$,
		this.getMenuLayout(),
	]).pipe(
		map(([state]) => state),
		tap(menuLayout => (this.menuLayout = menuLayout)),
		shareReplay({ refCount: true })
	);

	constructor(
		private menuLayoutService: MenuLayoutService,
		private menuLayoutStore: MenuLayoutStore
	) {}

	getMenuLayout() {
		return this.menuLayoutService.getMenuLayout().pipe(
			tap(menuLayout => {
				this.menuLayout = menuLayout;
				this.menuLayoutStore.updateMenuLayout(menuLayout);
			})
		);
	}

	updateMenuLayout(menuLayout: IMenuLayout) {
		return this.menuLayoutService.updateMenuLayout(menuLayout).pipe(
			tap(menuLayout => {
				this.menuLayout = menuLayout;
				this.menuLayoutStore.updateMenuLayout(menuLayout);
			})
		);
	}

	updateCategories(selected: ICategoryMenu[]) {
		return this.menuLayoutService.updateSelectedCategories(selected);
	}
}
